import { observable, makeObservable } from 'mobx';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { Payload } from '../Payload';

export class TextPayload extends Payload {
  @observable text;
  userMentions;

  constructor(data) {
    super({ ...data, payloadType: PayloadType.RichText });

    makeObservable(this);

    this.text = data.text;
    this.userMentions = data.userMentions;
    this.keyWord = data.keyWord || null;
    this.keyWords = data.keyWord ? [data.keyWord] : [];

    this.linkPreview = data.linkPreview || null;
    this.linkPreviewCancelled = data.linkPreviewCancelled || false;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      text: this.text,
      userMentions: this.userMentions,
      keyWord: this.keyWord || null,
      linkPreview: this.linkPreview || null,
      linkPreviewCancelled: this.linkPreviewCancelled || null,
    };
  }
}
